import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Platform pages (Phase A infra). Settings tabs (System, Notifications) are nested under the
// admin layout in modules/admin/routes.tsx; this file holds the Account page.
export const routes: RouteObject[] = [{ path: 'account/notifications', lazy: page(() => import('./my-notifications-page'), (m) => m.MyNotificationsPage) }];
export const orgRoutes: RouteObject[] = [];

export const settingsRoutes: RouteObject[] = [
  { path: 'system', lazy: page(() => import('./jobs-page'), (m) => m.JobsPage) },
  { path: 'notifications', lazy: page(() => import('./notification-settings'), (m) => m.NotificationSettingsPage) },
];
